/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'



const authBasePath = '/feedback'

const feedbackEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchFeedback: builder.query<any, string>({
    query: () => ({
      url: `${authBasePath}`,
      method: 'get',
    }),
  }),
  fetchEmailSubscriptions: builder.query<any, string>({
    query: () => `subscribe`
  })
})

export default feedbackEndpoints



